import React from 'react';
import { compose } from 'redux';


import {
  cloneDeep, orderBy
} from 'lodash';


import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';


import {
  Paginator, PrimaryControls, paginate
} from '../tableHelpers';


import _ from 'underscore';


import { translate } from 'react-i18next';

import { MobileCardList, MobileCard } from '../common/MobileCard';

function describeHistory(rowData, t) {
  var action, module;

  switch (rowData.action) {
    case "update":
      action = ' '+t("historyList.updated")+' '
      break;
  }

  switch (rowData.module) {
    case "product":
      module = t("historyList.the_product");
      break;

    case "user":
      module = t("historyList.the_user");
      break;

    case "group":
      module = t("historyList.the_group");
      break;
  }

  return rowData.origin_login + action + module + ' du client ' + rowData.login;
}

@translate(['common'])
export default class HistoryList extends React.Component {
  constructor(props) {
    super(props);



    this.state = {
      rows: this.props.history, // initial rows
      searchColumn: 'all',
      query: {}, // search query
      sortingColumns: null, // reference to the sorting columns
      columns: this.getColumns(), // initial columns
      pagination: { // initial pagination settings
        page: 1,
        perPage: 10
      },
      mAreaVisible: true,
      messageArea: ''
    };

    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);
    this.messageAreaChange = this.messageAreaChange.bind(this);
  }

  messageAreaChange(e) {

    this.setState({ messageArea: e.target.value })
  }


  componentDidUpdate(prevProps) {
    if (prevProps.history !== this.props.history) {
      this.setState({ rows: this.props.history })
    }
  }


  getColumns() {

    var self = this;

    const {t} = this.props

    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumns({ // sort.byColumn would work too
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      }
    });

    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);


    return [
      {
        property: 'date',
        header: {
          label:  t("main.date"),
          formatters: [sortableHeader],
          props: {
            className: "col-md-2"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },

      /*{
        property: 'origin_login',
        header: {
          label: 'Origine',
          formatters:[sortableHeader],
          props: {
            className: "col-md-2"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },
      
      {
        property: 'role',
        header: {
          label: 'Role',
          formatters:[sortableHeader],
          props: {
            className: "col-md-2"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },
      
      {
        property: 'action',
        header: {
          label: 'Action',
          formatters:[sortableHeader],
          props: {
            className: "col-md-3"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },
      
      {
        property: 'module',
        header: {
          label: 'Module',
          formatters:[sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },
      
      {
        property: 'origin_login',
        header: {
          label: 'Client cible',
          formatters:[sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },
      */
      {

        header: {
          label:  t("main.description"),
          formatters: [sortableHeader],
          props: {
            className: "col-md-6"
          }
        },
        cell: {
          formatters: [
            (value, { rowData }) => describeHistory(rowData, t)
          ]
        },
        visible: true
      },

      {
        property: 'payload',
        header: {
          label:  t("historyList.modifications"),
          formatters: [sortableHeader],
          props: {
            className: "col-md-4"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },

      /*{
        property: 'etat',
        header: {
          label: 'Etat',
          format: sortableHeader,
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [
            (value, { rowData }) => {
            	
            	var actionTxt = '';
            	
            	if( rowData.action.indexOf('create') > -1 ) {
            		actionTxt = 'a crée ';
            	} else if( rowData.action.indexOf('load') > -1 ) {
            		actionTxt = 'a chargé ';
            	} else if( rowData.action.indexOf('update') > -1 ) {
            		actionTxt = 'a mis à jour ';
            	}
            	
            	var moduleTxt = ''
            	
            	
            	
            	return (<span><i className="fa fa-circle" style={{"color":color}}/>{wbutton}</span>)

            }
          ]
        },
        visible: true
      },*/



    ];

  }




  render() {


    const {t} = this.props

    var columns = this.getColumns()

    const {
       rows, pagination, sortingColumns, searchColumn, query
    } = this.state;

    const cols = columns.filter(column => column.visible);
    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(rows);

    return (
      <div>
        {/*<VisibilityToggles
          columns={columns}
          onToggleColumn={this.onToggleColumn}
        />*/}

        <PrimaryControls
          className="controls"
          perPage={pagination.perPage}
          column={searchColumn}
          query={query}
          columns={cols}
          rows={rows}
          onPerPage={this.onPerPage}
          onColumnChange={this.onColumnChange}
          onSearch={this.onSearch}
          t={t}
        />

        <MobileCardList>
          {paginated.rows.map((rowData, i) =>
            <MobileCard
              key={rowData.id || i}
              title={rowData.date}
              subtitle={describeHistory(rowData, t)}
              fields={[
                { label: t("historyList.modifications"), value: rowData.payload }
              ]}
            />
          )}
        </MobileCardList>

        <div className="hidden-xs">
        <Table.Provider
          className="table table-striped"
          columns={cols}
          style={{ overflowX: 'auto' }}
        >
          <Table.Header>
            {/*<SearchColumns query={query} columns={cols} onChange={this.onSearch} />*/}
          </Table.Header>

          <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />

          {/*<CustomFooter columns={cols} rows={paginated.rows} />*/}
        </Table.Provider>
        </div>

        <div className="controls">
          <Paginator
            pagination={pagination}
            pages={paginated.amount}
            onSelect={this.onSelect}
            prevText={t("pagination.previous")}
            nextText={t("pagination.next")}
          />
        </div>
      </div>
    );
  }
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {

  }
  onColumnChange(searchColumn) {
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {
    this.setState({
      query
    });
  }
  onSelect(page) {
    const pages = Math.ceil(
      this.state.rows.length / this.state.pagination.perPage
    );

    this.setState({
      pagination: {
        ...this.state.pagination,
        page: Math.min(Math.max(page, 1), pages)
      }
    });
  }
  onPerPage(value) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        perPage: parseInt(value, 10)
      }
    });
  }

  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}